<template>
  <div class="card">
    <div class="card__content">
      <div class="card__member" v-if="entreprise.member">Membre</div>
      <h3 class="card__title">
        <span v-if="!entreprise.member" v-html="entreprise.title"></span>
        <router-link
          :to="{
            name: 'entreprise',
            params: {
              slug: entreprise.slug,
            },
          }"
          v-else
        >
          <span v-html="entreprise.title"></span>
        </router-link>
      </h3>
      <p class="card__section">
        {{
          entreprise.member_activite
            ? entreprise.member_activite
            : entreprise.section
        }}
      </p>
      <p class="card__adresse">{{ entreprise.adresse }}</p>
    </div>
    <router-link
      :to="{
        name: 'entreprise',
        params: {
          slug: entreprise.slug,
        },
      }"
      class="card__image"
      v-if="entreprise.member_logo"
    >
      <img :src="entreprise.member_logo" :alt="entreprise.title" />
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    entreprise: Object,
  },
};
</script>
<style lang="scss">
.card {
  display: flex;
  gap: 25px;
  margin: 0;
  padding: 25px;
  border: none;
  background-color: var(--white);
  &__inner {
    display: flex;
  }
  &__content {
    flex: 1 1 0;
  }
  &__member {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
    color: var(--green);
    font-size: 14px;
    font-weight: 600;
    &:before {
      content: "";
      width: 10px;
      height: 10px;
      margin-right: 5px;
      display: inline-block;
      position: relative;
      background-image: url("../assets/images/icons/icon-star.svg");
      background-size: 10px;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  &__title {
    margin: 0;
    padding: 0;
    color: var(--black);
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 5px;
    a {
      color: var(--black);
      text-decoration: none;
      text-underline-offset: 2px;
      &:hover {
        color: var(--green);
        text-decoration: underline;
      }
    }
  }
  p {
    margin-bottom: 0.3rem;
    color: var(--black);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    text-decoration: none;
  }
  &__adresse {
    &::before {
      content: "";
      width: 10px;
      height: 10px;
      margin-right: 5px;
      display: inline-block;
      position: relative;
      background-image: url("../assets/images/icons/icon-location.svg");
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  &__image {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 5px;
    background-color: rgb(250, 250, 250);
    overflow: hidden;
    @media (min-width: 768px) {
      width: 100px;
      height: 100px;
    }
    img {
      display: block;
      height: auto;
      width: auto;
      max-height: 70%;
      max-width: 70%;
    }
    &:hover {
      background-color: rgb(245, 245, 245);
      img {
      }
    }
  }
}
</style>
